import React from 'react'

import { Field } from 'formik'

import { Form, Col, Row } from '_zari/core'

import { ZeroesPad } from 'utils'

import * as InventarioService from 'services/inventario.service'

const SerieNumeroFormGroup = ({ fIsSubmitting, setFieldValue, tipoDocumentoValue }) => {
  const [checkedBox, setCheckedBox] = React.useState(false)

  const blurSerieDocumento = React.useCallback(
    e => {
      let valor = e.target.value
      if (/^[0-9]/.test(valor)) {
        valor = ZeroesPad(valor, 4)
        setFieldValue('serieDocumento', valor)
      }

      InventarioService.getSiguienteNumeroxSeriexTipoDocumento({
        serie: valor,
        tipoDocumento: tipoDocumentoValue,
        tipoOperacion: '91'
      }).then(({ data }) => {
        setFieldValue('numeroDocumento', data.siguienteNumero)
      })
    },
    [setFieldValue, tipoDocumentoValue]
  )

  const changeCheckbox = React.useCallback(() => {
    setCheckedBox(prev => !prev)
  }, [])

  return (
    <>
      <Form.Group>
        <Form.Label text='SERIE' htmlFor='input-serieDocumento' md={3} alignRightAt='md' />
        <Col md={9}>
          <Row>
            <Col md={5}>
              <Field name='serieDocumento'>
                {({ field }) => (
                  <Form.InputText
                    {...field}
                    id='input-serieDocumento'
                    disabled={fIsSubmitting}
                    className='zr-text-upper'
                    maxLength={4}
                    onBlur={blurSerieDocumento}
                  />
                )}
              </Field>
            </Col>
            <Col md={7} className='pl-0'>
              <Form.InputGroup>
                <Form.InputGroup.Checkbox aria-label='Checkbox for following text input' checked={checkedBox} onChange={changeCheckbox} />
                <Field name='numeroDocumento'>{({ field }) => <Form.InputText {...field} id='input-numeroDocumento' disabled={!checkedBox} />}</Field>
              </Form.InputGroup>
            </Col>
          </Row>
        </Col>
      </Form.Group>
    </>
  )
}

export default React.memo(SerieNumeroFormGroup)
